(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
  // Category Carousel — vanilla JS, en instans per section
  (function () {
    function initCarousel(root) {
      if (!root || root.dataset.ccInit === '1') return;
      root.dataset.ccInit = '1';

      var track   = root.querySelector('[data-track]');
      var prevBtn = root.querySelector('.cat-carousel__nav--prev');
      var nextBtn = root.querySelector('.cat-carousel__nav--next');
      var fadeL   = root.querySelector('.cat-carousel__fade--left');
      var fadeR   = root.querySelector('.cat-carousel__fade--right');

      if (!track) return;

      // Räkna ut scroll-avstånd: ca 80% av synlig bredd
      function stepSize() {
        return Math.max(200, Math.floor(track.clientWidth * 0.8));
      }

      function updateUI() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        var atStart = track.scrollLeft <= 1;
        var atEnd   = track.scrollLeft >= maxScroll;
        var overflows = track.scrollWidth > track.clientWidth + 2;

        if (prevBtn) prevBtn.hidden = !overflows || atStart;
        if (nextBtn) nextBtn.hidden = !overflows || atEnd;
        if (fadeL)   fadeL.hidden = !overflows || atStart;
        if (fadeR)   fadeR.hidden = !overflows || atEnd;
      }

      function scrollByDir(dir) {
        var delta = stepSize() * (dir === 'next' ? 1 : -1);
        track.scrollBy({ left: delta, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByDir('prev'); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByDir('next'); });

      // Pointer drag (desktop mouse). Touch/swipe hanteras nativt via overflow.
      var isDown = false, startX = 0, startScroll = 0, moved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        // Börja inte drag om användaren klickar på en länk/knapp
        if (e.target.closest('a, button')) return;
        isDown = true; moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.style.scrollBehavior = 'auto';
        track.style.cursor = 'grabbing';
        e.preventDefault();
      });
      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 5) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function endDrag(e) {
        if (!isDown) return;
        isDown = false;
        track.style.scrollBehavior = '';
        track.style.cursor = '';
        if (moved) {
          // Förhindra klick på länk direkt efter drag
          var block = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          track.addEventListener('click', block, { capture: true, once: true });
        }
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      // Uppdatera UI vid scroll/resize/bild-load
      track.addEventListener('scroll', updateUI, { passive: true });
      window.addEventListener('resize', updateUI);
      track.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', updateUI, { once: true });
      });

      // Init
      updateUI();
      // Extra tick efter fontlast/layout
      setTimeout(updateUI, 100);
      setTimeout(updateUI, 500);
    }

    function initAll() {
      document.querySelectorAll('[data-cat-carousel]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor: re-init när section laddas/uppdateras
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-cat-carousel]');
      if (el) initCarousel(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
